export type Option = {
  value: string | number;
  label: string;
  description?: string;
};

export function toOptions<T extends { id: number | string }>(
  items: T[],
  orderBy?: string,
  getLabel?: (item: T) => string,
  getDescription?: (item: T) => string,
  getKey?: (item: T) => string | number,
): Option[] {
  const sorted = orderBy
    ? [...items].sort((a, b) => {
        const desc = orderBy.startsWith("-");
        const key = (desc ? orderBy.slice(1) : orderBy) as keyof T;

        return (a[key] < b[key] ? -1 : 1) * (desc ? -1 : 1);
      })
    : items;

  return sorted.map((item) => ({
    value: getKey ? getKey(item) : item.id,
    label: getLabel ? getLabel(item) : (item as any).name,
    description: getDescription ? getDescription(item) : undefined
  }));
}
